<template><svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9">
  <path d="M1.5 5.383L3.326 7.5l5.174-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>